import { useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

const KEY = "fz_token";

export function setToken(t) {
  try { if (t) localStorage.setItem(KEY, t); } catch { /* ignore */ }
}

export function getStoredToken() {
  try { return localStorage.getItem(KEY) || "demo"; } catch { return "demo"; }
}

// Resolve the active token: prefer a fresh token in the URL (from an ATS/share link),
// persist it, then fall back to the stored one. Never keeps the token in the URL.
export function useToken() {
  const [params] = useSearchParams();
  const urlToken = params.get("token");
  if (urlToken) setToken(urlToken);
  return urlToken || getStoredToken();
}

// Mounted once at the app root: persists any ?token= from the URL then strips it,
// so users only ever see clean page paths (e.g. /play, /sudoku).
export function TokenStripper() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const urlToken = params.get("token");
  useEffect(() => {
    if (!urlToken) return;
    setToken(urlToken);
    const sp = new URLSearchParams(location.search);
    sp.delete("token");
    const rest = sp.toString();
    navigate(location.pathname + (rest ? `?${rest}` : ""), { replace: true });
  }, [urlToken, location.pathname, location.search, navigate]);
  return null;
}
